import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { TimerIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon, LockIcon, UsersIcon, GiftIcon, CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function PricingSection() {
  const [buyers, setBuyers] = useState(47);
  useEffect(() => {
    const interval = setInterval(() => {
      setBuyers(prev => prev + (Math.random() > 0.5 ? 1 : 0));
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return <SectionWrapper id="pricing" className="relative" data-id="element-487">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-cyber-neon/8 rounded-full blur-[120px] pointer-events-none" data-id="element-488"></div>

      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-489">
        <p className="text-gray-300 mb-6 text-base" data-id="element-490">
          Sabemos que como estudiante o joven en LATAM, cada dólar cuenta. Por
          eso, solo por las próximas 24 horas:
        </p>

        <div className="bg-cyber-dark border-2 border-cyber-neon rounded-2xl p-6 md:p-10 shadow-neon-strong relative overflow-hidden" data-id="element-491">
          <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.2)_50%)] bg-[length:100%_4px] pointer-events-none opacity-15" data-id="element-492"></div>

          <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-cyber-neon text-cyber-black font-bold font-mono text-xs px-5 py-1 rounded-b-lg" data-id="element-493">
            🔥 OFERTA DE LANZAMIENTO
          </div>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-2 mt-4 mb-4 text-gray-400 text-xs font-mono" data-id="element-494">
            <UsersIcon className="w-3.5 h-3.5 text-cyber-neon" data-id="element-495" />
            <span data-id="element-496">{buyers} personas compraron hoy</span>
          </div>

          <div className="mb-1" data-id="element-497">
            <span className="text-gray-500 font-mono text-lg line-through decoration-cyber-red decoration-2" data-id="element-498">
              $121
            </span>
          </div>

          <motion.div animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="mb-4" data-id="element-499">
            <h3 className="text-5xl md:text-7xl font-bold font-mono text-cyber-neon text-shadow-neon-strong" data-id="element-500">
              $9.99 <span className="text-xl text-cyber-neon/60" data-id="element-501">USD</span>
            </h3>
          </motion.div>

          <p className="text-gray-400 italic text-sm mb-6" data-id="element-502">
            Menos de lo que cuesta una salida a comer que igual te da ansiedad.
          </p>

          <motion.div animate={{
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-503">
            <NeonButton size="lg" fullWidth href={CHECKOUT_URL} className="text-lg md:text-xl py-5" data-id="element-504">
              🚀 SÍ, QUIERO HACKEAR MI ANSIEDAD → $9.99{' '}
              <ArrowRightIcon className="w-5 h-5" data-id="element-505" />
            </NeonButton>
          </motion.div>

          {/* Bonus badge */}
          <div className="flex flex-col items-center gap-1 mt-4" data-id="element-506">
            <div className="flex items-center justify-center gap-1.5 text-xs font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-4 py-1.5 shadow-[0_0_10px_rgba(57,255,20,0.12)]" data-id="element-507">
              <GiftIcon className="w-3.5 h-3.5 text-cyber-neon animate-pulse" data-id="element-508" />
              <span className="text-gray-300" data-id="element-509">
                + 2 Bonos <strong className="text-cyber-neon" data-id="element-510">GRATIS</strong>{' '}
                incluidos <span className="text-gray-500" data-id="element-511">(valor $47)</span>
              </span>
            </div>
            <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5" data-id="element-512">
              <div className="flex items-start gap-2" data-id="element-513">
                <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-514" />
                <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-515">
                  <span className="text-gray-300 font-bold" data-id="element-516">Bonus 1:</span>{' '}
                  Scripts de Supervivencia en Citas — qué decir para que nunca
                  haya silencios incómodos.
                  <span className="ml-1 text-gray-500 line-through" data-id="element-517">$25</span>
                  <span className="ml-1 text-cyber-neon font-bold" data-id="element-518">GRATIS</span>
                </p>
              </div>
              <div className="flex items-start gap-2" data-id="element-519">
                <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-520" />
                <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-521">
                  <span className="text-gray-300 font-bold" data-id="element-522">Bonus 2:</span>{' '}
                  Templates de Texto Irresistibles — para que nunca más te dejen
                  en "visto" en WhatsApp.
                  <span className="ml-1 text-gray-500 line-through" data-id="element-523">$22</span>
                  <span className="ml-1 text-cyber-neon font-bold" data-id="element-524">GRATIS</span>
                </p>
              </div>
              <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-525">
                <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-526">
                  Te ahorras $47 USD en bonos de regalo
                </p>
              </div>
            </div>
            <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors" data-id="element-527">
              Leer más
            </button>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-4 text-[10px] text-gray-500 font-mono" data-id="element-528">
            <span className="flex items-center gap-1" data-id="element-529">
              <LockIcon className="w-3 h-3 text-cyber-neon" data-id="element-530" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-531">
              <ZapIcon className="w-3 h-3 text-cyber-neon" data-id="element-532" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-533">
              <ShieldCheckIcon className="w-3 h-3 text-cyber-neon" data-id="element-534" /> Garantía 7
              días
            </span>
          </div>

          <div className="mt-4 flex items-center justify-center gap-2 text-cyber-red font-mono text-xs" data-id="element-535">
            <TimerIcon className="w-3.5 h-3.5 animate-pulse" data-id="element-536" />
            <span data-id="element-537">
              Oferta para los primeros 50 compradores. Luego sube a $121.
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}